import apiChange from '../apiChange';

import { ParamsDataGetStatus } from 'utils/typeServices';

type response = {
    success: boolean;
    message: string;
    errorCode: string;
    data: ParamsDataGetStatus;
}

export const GetStatus = async (GUID_COTACAO: string) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.get<response>(`/changeservice/GetStatus/v1?GUID_COTACAO=${GUID_COTACAO}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
